export default (palette, isDarkMode) => ({
  paper: {
    backgroundColor: palette.background.paper,
    border: `1px solid ${palette.divider}`,
    boxShadow: isDarkMode
      ? '0px 8px 24px rgba(0, 0, 0, 0.5)'
      : '0px 8px 24px rgba(10, 37, 64, 0.1)',
  },
})
